export default {
	main: {
		home: {
			icon: 'home',
		},
		orders: {
			icon: 'shopping-cart',
		},
		shop: {
			icon: 'building-store',
			children: {
				products: {
					icon: 'shopping-bag',
				},
                services: {
                    icon: 'receipt',
                },
				categories: {
					icon: 'checkbox',
				},
                priceTypes: {
                    icon: 'list-details',
                },
                tariffRequests: {
                    icon: 'bonus-history',
                },
                customers: {
                    icon: 'user',
                },
                promotions: {
                    icon: 'circle',
                },
			},
		},
		// marketing: {
		// 	icon: 'percent',
		// 	children: {
		// 		bonusSettings: {
		// 			icon: 'tags',
		// 		},
		// 		bonusHistory: {
		// 			icon: 'bonus-history',
		// 		},
		// 		promocodes: {
		// 			icon: 'number-123',
		// 		},
		// 		historyPromocodes: {
		// 			icon: 'promo-history',
		// 		},
		// 		promotions: {
		// 			icon: 'circle',
		// 		},
		// 		banners: {
		// 			icon: 'rectangle',
		// 		},
		// 		rewards: {
		// 			icon: 'gift',
		// 		},
		// 		jettons: {
		// 			icon: 'badge',
		// 		},
		// 		notifications: {
		// 			icon: 'message',
		// 		},
		// 	},
		// },
		// statistics: {
		// 	icon: 'activity',
		// },
		// communications: {
		// 	icon: 'accessible',
		// 	children: {
		// 		reviews: {
		// 			icon: 'star',
		// 		},
		// 		questionReviews: {
		// 			icon: 'questions',
		// 		},
		// 		chats: {
		// 			icon: 'brand-wechat',
		// 		},
		// 		tickets: {
		// 			icon: 'brand-hipchat',
		// 		},
		// 	},
		// },
		settings: {
			icon: 'settings',
			children: {
				settings: {
					icon: 'adjustments-horizontal',
				},
				delivery: {
					icon: 'truck',
				},
				// contents: {
				// 	icon: 'book',
				// },
				users: {
					icon: 'user-cog',
				},
				// import: {
				// 	icon: 'download',
				// },
			},
		},
	},

	account: {
		profile: {
			icon: 'user',
		},
		logout: {
			icon: 'power',
			action: 'logout',
		},
	},
}